import React from 'react';
import cx from 'classnames';

import styles from './UnreadIndicator.module.scss';

export const UnreadIndicator: React.FC<
    {testId: string; withBorder?: boolean} & React.ComponentProps<'div'>
> = ({className, testId, withBorder, ...props}) => (
    <div
        {...props}
        data-testid={testId}
        className={cx(
            styles.container,
            {[styles.withBorder]: withBorder},
            className,
        )}
    />
);
